import { App } from 'vue'
import FloatingVue from 'floating-vue'

export default {
  install(app: App<Element>): any {
    app.use(FloatingVue)
  }
}
